export default {"src":"/_next/static/media/qiwi.28971d0e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};